import { render, staticRenderFns } from "./ThankYouPage.vue?vue&type=template&id=46aeed6c&scoped=true&"
import script from "./ThankYouPage.vue?vue&type=script&lang=ts&"
export * from "./ThankYouPage.vue?vue&type=script&lang=ts&"
import style0 from "./ThankYouPage.vue?vue&type=style&index=0&id=46aeed6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aeed6c",
  null
  
)

export default component.exports